
export class UIFont {
    constructor() {
    

    this.currentSize = 0.9; // Default font-size (1em)
    this.minSize = 0.8;
    this.maxSize = 1.2;
    this.step = 0.1;
};

updateFontSize = function () {
    document.querySelectorAll(".fontwrap").forEach(el => {
        var fontsz = this.currentSize + 'em';
        el.style.fontSize = fontsz;
        console.log(this.currentSize);
    });
};

increaseFont = function () {
    if (this.currentSize < this.maxSize) {
        this.currentSize = parseFloat((this.currentSize + this.step).toFixed(2));
        this.updateFontSize();
    }
};

decreaseFont = function () {
    if (this.currentSize > this.minSize) {
        this.currentSize = parseFloat((this.currentSize - this.step).toFixed(2));
        this.updateFontSize();
    }
};
}
